import { NGSModuleMetadata, NGSModule, SyncInit } from "~/core/module";
import { ModuleKeys, NGSModules } from "./registry";
import noScroll from "no-scroll";

export class Header extends NGSModule implements SyncInit {
  private header: HTMLElement = document.querySelector("#header")!;
  private toggle: HTMLElement = document.querySelector("[data-header-toggle]")!;
  private mobile: HTMLElement = document.querySelector("[data-header-mobile]")!;

  private opsMenu: HTMLElement = document.querySelector("[data-header-ops]")!;

  private aboutMenu: HTMLElement = document.querySelector(
    "[data-header-about]"
  )!;

  private userMenu: HTMLElement = document.querySelector("[data-header-user]")!;

  private ops: HTMLElement = document.querySelector("[data-header-menu-ops]")!;

  private about: HTMLElement = document.querySelector(
    "[data-header-menu-about]"
  )!;

  private user: HTMLElement = document.querySelector(
    "[data-header-menu-user]"
  )!;

  private listeners: Array<() => void> = [];

  private opened: "ops" | "about" | "user" | null = null;

  private hamburgerIcon = `<span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>`;

  private backIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-left"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg>`;

  protected meta(): NGSModuleMetadata {
    return NGSModules.header;
  }

  constructor() {
    super();
    // Bind handlers
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleOps = this.toggleOps.bind(this);
    this.toggleAbout = this.toggleAbout.bind(this);
    this.toggleUser = this.toggleUser.bind(this);
  }

  init(): void {
    this.setup();
  }

  destroy(): void {
    this.toggle?.removeEventListener("click", this.toggleMenu);
  }

  private toggleMenu() {
    if (this.opened) {
      this.toggle.innerHTML = this.hamburgerIcon;
      switch (this.opened) {
        case "ops":
          this.toggleOps();
          break;
        case "about":
          this.toggleAbout();
          break;
        case "user":
          this.toggleUser();
          break;
      }
      return;
    }

    noScroll.toggle();

    this.toggle.classList.toggle("is-active");
    this.mobile.classList.toggle("translate-y-full");
  }

  private toggleOps() {
    if (this.opsMenu.classList.contains("translate-x-full")) {
      this.opsMenu.classList.remove("translate-x-full");
      this.opened = "ops";
      this.toggle.innerHTML = this.backIcon;
    } else {
      this.opsMenu.classList.add("translate-x-full");
      this.opened = null;
    }
  }

  private toggleUser() {
    if (this.userMenu.classList.contains("translate-x-full")) {
      this.userMenu.classList.remove("translate-x-full");
      this.opened = "user";
      this.toggle.innerHTML = this.backIcon;
    } else {
      this.userMenu.classList.add("translate-x-full");
      this.opened = null;
    }
  }

  private toggleAbout() {
    if (this.aboutMenu.classList.contains("translate-x-full")) {
      this.aboutMenu.classList.remove("translate-x-full");
      this.opened = "about";
      this.toggle.innerHTML = this.backIcon;
    } else {
      this.aboutMenu.classList.add("translate-x-full");
      this.opened = null;
    }
  }

  private setup() {
    this.toggle?.addEventListener("click", this.toggleMenu);
    this.ops?.addEventListener("click", this.toggleOps);
    this.about?.addEventListener("click", this.toggleAbout);
    this.user?.addEventListener("click", this.toggleUser);
    // this.toggle.classList.toggle("is-active");
    // this.mobile.classList.toggle("translate-y-full");
  }
}
